
import Vue from 'vue';

export default Vue.extend({
	name: 'RibbonBanner',

	props: {
		width: {
			type: [Number, String],
			default: 100
		},

		height: {
			type: [Number, String],
			default: 100
		},

		backgroundColor: {
			type: String,
			default: 'grey'
		},

		text: {
			type: String,
			default: 'FooBar'
		},

		textColor: {
			type: String,
			default: 'white'
		}
	}
});
